import React, { FC } from 'react';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { PrintRodRequestProps } from './types';
import { useName } from '@bechtel/client-common';
import { map } from 'lodash';
import { Trans } from '@lingui/macro';
import { QRCodeImageStyled, PrintBoxStyled, DashedBorderStyled } from './styled';
// @ts-ignore: svg declarations not recognising
import { ReactComponent as ArcStrykerSmallLogo } from '@bechtel/client-assets/dist/images/arc-stryker-black-logo.svg';
import { QRScannerURL } from './mock';
export const PrintRodRequest: FC<PrintRodRequestProps> = React.forwardRef((props, ref) => {
  const { getFullName } = useName();
  const { rodRequest } = props;
  const stencils = map(rodRequest.stencils, (stencil) => {
    return stencil.stencil.badgeNumber;
  });
  return (
    <div ref={ref}>
      <Box
        justifyContent={{ sm: 'center' }}
        alignItems={{ sm: 'center' }}
        px={{ sm: '450' }}
        pt={{ sm: '450' }}
        pb={{ sm: '550' }}
      >
        <PrintBoxStyled>
          <Box
            justifyContent={{ sm: 'space-between' }}
            ml={{ sm: '400' }}
            my={{ sm: '400' }}
            alignItems={{ sm: 'center' }}
          >
            <ArcStrykerSmallLogo />

            <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'end' }}>
              <Box mb={{ sm: '200' }}>
                <Text size="300" color="black">
                  <Trans>Rod Room Slip</Trans>
                </Text>
              </Box>

              <Text size="200" weight="600" color="black">
                {rodRequest.rodRoom.name}
              </Text>
            </Box>
          </Box>
          <DashedBorderStyled />
          <Box mt={{ sm: '450' }}>
            <Text size="100">
              <Trans>**QR code (For Rod Room use only)</Trans>
            </Text>
          </Box>
          <Box mt={{ sm: '300' }}>
            {/* TODO : need to implement QR code when backend will implemented  */}
            <QRCodeImageStyled src={QRScannerURL} />
          </Box>
          <DashedBorderStyled />
          <Box flexDirection={{ sm: 'column' }} mt={{ sm: '550' }}>
            <Box mt={{ sm: '200' }} justifyContent={{ sm: 'space-between' }}>
              <Box mr={{ sm: '500' }}>
                <Text size="200">
                  <Trans>Rod Request:</Trans>
                </Text>
              </Box>
              <Box ml={{ sm: '500' }}>
                <Text size="200">{rodRequest.requestNumber}</Text>
              </Box>
            </Box>

            <Box mt={{ sm: '200' }} justifyContent={{ sm: 'space-between' }}>
              <Box mr={{ sm: '500' }}>
                <Text size="200">
                  <Trans>Request By:</Trans>
                </Text>
              </Box>
              <Box ml={{ sm: '500' }}>
                <Text size="200">{getFullName(rodRequest?.createdBy?.firstName, rodRequest?.createdBy?.lastName)}</Text>
              </Box>
            </Box>

            <Box justifyContent={{ sm: 'space-between' }} mt={{ sm: '200' }}>
              <Box mr={{ sm: '500' }}>
                <Text size="200">
                  <Trans>Stencil:</Trans>
                </Text>
              </Box>
              <Box ml={{ sm: '500' }}>
                <Text size="200">{stencils.filter((id) => id).join(',')}</Text>
              </Box>
            </Box>
          </Box>
          <Box mt={{ sm: '550' }} flexDirection={{ sm: 'column' }}>
            <Text size="200" weight="600">
              <Trans>Filler Materials</Trans>
            </Text>

            <Box flexDirection={{ sm: 'column' }} mt={{ sm: '200' }}>
              {map(rodRequest.fillerMaterials, (fillerMaterial) => {
                return (
                  <Box mt={{ sm: '200' }} justifyContent={{ sm: 'space-between' }}>
                    <Text size="200">{fillerMaterial.fillerMaterial.label}:</Text>
                    <Text size="200">{map(fillerMaterial.diameters, 'label').join(',')}</Text>
                  </Box>
                );
              })}
            </Box>
          </Box>
          <DashedBorderStyled mt={{ sm: '550' }} />
          <Box flexDirection={{ sm: 'column' }} mt={{ sm: '550' }}>
            <Text size="100" weight="600">
              <Trans>Comments:</Trans>
            </Text>

            <Box mt={{ sm: '200' }}>
              {map(rodRequest?.comments, (comment) => {
                return (
                  <Box mt={{ sm: '200' }}>
                    <Text size="200">{comment.comment}</Text>
                  </Box>
                );
              })}
            </Box>
          </Box>
          <DashedBorderStyled mt={{ sm: '550' }} />
          <Box justifyContent={{ sm: 'center' }} mt={{ sm: '550' }} css={{ pageBreakBefore: 'always' }}>
            <Text size="100" weight="600">
              <Trans>**Welders, please check the boxes which were progressed by you.</Trans>
            </Text>
          </Box>
          <Box justifyContent={{ sm: 'center' }} mt={{ sm: '550' }} alignItems={{ sm: 'center' }}>
            <DashedBorderStyled />
            <Text size="100" style={{ whiteSpace: 'nowrap' }}>
              <Trans>Associated welds</Trans>
            </Text>
            <DashedBorderStyled />
          </Box>
          <Box mt={{ sm: '450' }}>
            {map(rodRequest.welds, (weld) => {
              return (
                <Box flexDirection={{ sm: 'column' }} mt={{ sm: '500' }}>
                  <Box my={{ sm: '200' }}>
                    <Text size="200">{weld.tag}</Text>
                  </Box>
                  <Box mt={{ sm: '300' }} justifyContent={{ sm: 'space-between' }}>
                    <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-between' }}>
                      <Text size="200">
                        <Trans>Welded:</Trans>
                      </Text>
                      <Box ml={{ sm: '450' }}>
                        <Checkbox checked={false} readOnly />
                      </Box>
                    </Box>
                    <Box alignItems={{ sm: 'center' }} ml={{ sm: '600' }} justifyContent={{ sm: 'space-between' }}>
                      <Text size="200">
                        <Trans>Complete:</Trans>
                      </Text>
                      <Box ml={{ sm: '450' }}>
                        <Checkbox checked={false} readOnly />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box mt={{ sm: '800' }}>
            <Text size="100" weight="600">
              <Trans>**Scan this section separately to status the welds (for Rod Room use only)</Trans>
            </Text>
          </Box>
        </PrintBoxStyled>
      </Box>
    </div>
  );
});
